require('./bootstrap');
import Vue from "vue";


import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
    // This is the default
    inject: true,
    // Important to name this something other than 'fields'
    fieldsBagName: 'veeFields',
    // This is not required but avoids possible naming conflicts
    errorBagName: 'veeErrors',
});
Vue.component('form-dsa-reg', require('./components/site-form/dsa/dsa-reg.vue').default);
Vue.component('customer-login', require('./components/site-form/customer/auth/login.vue').default);
Vue.component('employee-login', require('./components/site-form/employee/auth/login.vue').default);


const config = {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: null,
    errorBagName: 'errors', // change if property conflicts
    events: 'input|blur',
    fieldsBagName: 'fields',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: true,
    locale: 'en',
    validity: false,
    useConstraintAttrs: true,
};

var app = new Vue({
    el: '#app',
});
